<script setup>
import MediaBankEntry from './util/media-bank-entry.vue';
import {computed} from "vue";

const props = defineProps({
    containerRef: {
        type: String,
        required: true
    },
    uuid: {
        type: String,
        require: true
    },
    content: {
        type: Object,
        required: true
    },
})

const alignmentClass = computed(() => {
    if (props.content?.alignment === 'left') {
        return 'justify-start'
    }
    if (props.content?.alignment === 'center') {
        return 'justify-center'
    }
    if (props.content?.alignment === 'right') {
        return 'justify-end'
    }
    if (props.content?.alignment === 'fullwidth') {
        return 'justify-stretch'
    }

    return 'justify-center'
})

const roundingClass = computed(() => {
    if (props.content?.rounding === 'siteAppearance') {
        return 'rounded-wl'
    }
    if (props.content?.rounding === 'none') {
        return 'rounded-none'
    }
    if (props.content?.rounding === 'slight') {
        return 'rounded-lg'
    }
    if (props.content?.rounding === 'medium') {
        return 'rounded-3xl'
    }
    if (props.content?.rounding === 'very') {
        return 'rounded-5xl'
    }

    return 'rounded-wl'
})

const maxDimensionsStyle = computed(() => {
    const style = {}
    if (props.content.max_width && props.content.alignment !== 'fullwidth') {
        style.maxWidth = props.content.max_width + props.content.max_width_unit
    }
    return style
})

</script>
<template>
    <div>
        <div
            v-if="props.content"
            class="flex mx-auto overflow-hidden rounded-custom shadow-custom"
            :class="alignmentClass"
        >
            <component
                :is="props.content?.link_url? 'a' : 'div'"
                :href="props.content?.link_url"
                target="_blank"
                class="text-inherit"
                :class="props.content?.alignment === 'fullwidth' ? 'w-full' : ''"
                :style="maxDimensionsStyle"

            >
                <div
                    class="overflow-hidden"
                    :class="roundingClass"
                >
                    <MediaBankEntry
                        v-if="props.content.source_type === 'mediaLibrary' && props.content.media_bank_entry_id"
                        :container-ref="containerRef"
                        :block-uuid="uuid"
                        :block-content="props.content"
                        :media-bank-entry-id="props.content.media_bank_entry_id"
                        :alt-text="props.content.alt_text"
                        property-name="media_bank_entry_id"
                        :class="props.content?.alignment === 'fullwidth' ? 'w-full' : ''"
                        :style="{aspectRatio: 1 / props.content.media_height_aspect}"
                    ></MediaBankEntry>
                    <img
                        v-if="props.content.source_type === 'pexels' || props.content.source_type === 'url'"
                        :alt="props.content.alt_text"
                        :src="props.content.media_url"
                        :style="{aspectRatio: 1 / props.content.media_height_aspect}"
                    />
                </div>
                <p
                    v-if="props.content.caption"
                    class="mt-1 text-xs text-center"
                >
                    {{ content.caption}}
                </p>
            </component>
        </div>
    </div>
</template>
